import Grid from '@mui/material/Grid';
import type { InventoryAndContentState } from '@openx/types/targeting/inventoryAndContent.ts';
import type { AnyAction } from '@reduxjs/toolkit';
import type { JSX } from 'react';
import { AdUnitSizeDropdown } from '../AdUnitSizeDropdown/AdUnitSizeDropdown.tsx';

interface AdUnitSizeProps {
  targetingParams: InventoryAndContentState;
  dispatchInventory: (action: AnyAction) => void;
}

export const AdUnitSize = ({ targetingParams, dispatchInventory }: AdUnitSizeProps): JSX.Element => (
  <Grid size={12}>
    <AdUnitSizeDropdown targetingParams={targetingParams} dispatchInventory={dispatchInventory} />
  </Grid>
);
